module.exports = __webpack_public_path__ + "img/9788949120850.2c12fd5f.jpg";